const proposalEvaluationTypes = Object.freeze({
  RelacionadosPropuestasRenovacion: 3,
  RelacionadosPropuestasNueva: 4,
  PropuestaServiciosEducativasNueva: 5,
  PropuestaServiciosEducativasRenovacion: 6,
  EducativosServiciosRelacionadosNueva: 7,
  EducativosServiciosRelacionadosRenovacion: 8,
});

export default proposalEvaluationTypes;
